<template>
  <div>
    <div class="page-container">
      <div class="titie">智能称管理</div>
      <Form :dialogFormVisible="dialogFormVisible" @controlFormWindow="controlFormWindow"  :ruleForm = "ruleForm" @getSmartList="getSmartList"/>
        <Table :headerData="headerData" :tableData="tableData" :tableText="tableText" :tableCount="tableCount " :border="true" @changeTable="changeTable">
          <el-table-column
                  label="状态"
                  width="100"
                  align="center">
            <template slot-scope="scope">
              {{scope.row.ONLINE_STATUS === '0'?'离线':'在线'}}

            </template>
          </el-table-column>
          <el-table-column
          fixed="right"
          label="操作"
          width="130"
          align="center">
          <template slot-scope="scope">
            <el-button @click="checkDetail(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteDetail(scope.row)" type="text" size="small" style="color: red">删除</el-button>
          </template>
          </el-table-column>
        </Table>
      </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Table from 'components/Table'
import { Header } from '../smartSaid/headerData.js'
import Form from '../smartSaid/Form'
import cabinetSet from 'api/Management/cabinetSet.js'
const _cabinetSet = new cabinetSet()
export default {
  data() {
    return {
        dialogFormVisible: false,
        ruleForm:{},
        // 表单必须数据
        headerData: Header,
        tableData: [], // 表格数据
        tableText: '加载中',
        tableCount: 0,
        selectedStr: '', // 选择的表格选择字符串
        currentPage: 1, // 当前页
        currentPageLength: 10, // 当前页长度
    }
  },
    mounted(){
        this.getSmartList()
    },
    methods:{
        getSmartList(){
            this.tableData = []
            this.tableText = '加载中'
            _cabinetSet.getSmartList(this.per_page,this.currentPage).then(res => {
                this.tableData = res.items
                this.tableCount = res._meta.totalCount
                if(res.items.length === 0 ) {
                    this.tableText = '暂无数据'
                }
            })
        },
        // 改变页数/页长度
        changeTable({currentPage, pageLength}) {
            this.tableData = []
            // 临时存储当前页/当前页长度
            this.currentPage = currentPage
            this.currentPageLength = pageLength
            this.per_page = pageLength
            this.getSmartList()
        },
        // 编辑
        checkDetail(row){
          this.dialogFormVisible = true
            _cabinetSet.getSmartDdtail( row.SEQ_NO).then(res => {
                this.ruleForm = res
            })
        },
        controlFormWindow(flag) {
          this.dialogFormVisible = flag
        },
        deleteDetail(){

        }

    },
  components: {
      Table,
      Form
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .titie {
    width 100%
    height 30px
    line-height 30px
    font-size:16px;
    font-family:SimSun;
    font-weight:bold;
    color:rgba(62,62,62,1)
    text-align center
  }
</style>

